import React, { useState } from 'react';

import Support from './Support';

// import Card1 from '../img/twt-covid-19.jpg';
// import Card2 from '../img/covid-19-track.jpg';
// import Card3 from '../img/disordered.jpg';
// import Card4 from '../img/oomm.jpg';

function Footer(){
    const [year] = useState(new Date().getFullYear())
    // const readmoreArr =[
    //     {"img": Card1, "title":"The Whole Truth: Covid-19 Vaccination", "intro":"Stuff’s fact-checking project on Covid-19 vaccination","autor":"","link":"https://interactives.stuff.co.nz/2021/the-whole-truth-covid-19-vaccine/#/"},
    //     {"img": Card2, "title":"Coronavirus tracked", "intro":"Live graphs of vaccinations, cases, deaths and spread of Covid-19","autor":"Felippe Rodrigues","link":"https://interactives.stuff.co.nz/2020/05/coronavirus-covid-19-new-zealand-latest-data-cases/"},
    //     {"img": Card3, "title":"Disordered", "intro":"The shame of how we treat people with FASD","autor":"Stuff Circuit","link":"https://interactives.stuff.co.nz/2022/03/circuit/disordered-fasd-new-zealand-alcohol-disability/"},
    //     {"img": Card4, "title":"Out of My Mind", "intro":"True stories about mental health","autor":"Adam Dudding","link":"https://interactives.stuff.co.nz/2019/08/out-of-my-mind-podcast/"},
    // ]
       return (
        <React.Fragment>
        <Support />
        <div className="footercontainer">
            {/* <div className="readmore-container">
            <span className="readmore-container--title">Read more about Te Māramatanga from Stuff</span>
            <div className="readmore-container--linkbox">
            {readmoreArr.map((story,index)=>(
            <a key={index} className="readmore-container--content" href={story.link} target="_top">
            <div className="readmore-container--content--thumbnail" style={{backgroundImage:`url(${story.img})`}}></div>
            <div className="readmore-container--content--info">
            <span>{story.title}</span>
            <span>{story.intro}</span>
            <span>{story.autor ? `By ${story.autor}`:""}</span>
            </div>
            </a>
            ))} 
            </div>
            </div> */}
            <span className="footercontainer--copy">&copy; {year} Stuff Limited</span>
        </div>
        </React.Fragment>
       );
}


export default Footer;